import script from "./staffs.vue?vue&type=script&setup=true&lang=js"
export * from "./staffs.vue?vue&type=script&setup=true&lang=js"

import "./staffs.vue?vue&type=style&index=0&id=98e41742&lang=css"

const __exports__ = script;

export default __exports__